import Vue from 'vue'
import myDialog from '@/components/dialog/myDialog1.vue'
import store from '@/store/index'

const createDiv = (id) => {
  let isExit = document.querySelector('#' + id)
  if (!isExit) {
    let isExit = document.createElement('div')
    isExit.id = id
    document.body.appendChild(isExit)
  }
  return isExit
}
export function initMyDialog() {
  const dialogId = 'myDialog'
  const dialogModel = Vue.extend(myDialog)
  createDiv(dialogId)
  return new dialogModel({ store }).$mount('#' + dialogId)
}
